import { render } from "./ConsultaRenderedFile.vue?vue&type=template&id=599134ad&scoped=true"
import script from "./ConsultaRenderedFile.vue?vue&type=script&lang=js"
export * from "./ConsultaRenderedFile.vue?vue&type=script&lang=js"

import "./ConsultaRenderedFile.vue?vue&type=style&index=0&id=599134ad&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599134ad"]])

export default __exports__